import { __ } from '@wordpress/i18n';
import { Card } from '@getdokan/dokan-ui';
import { useDispatch } from '@wordpress/data';
import { VENDOR_QUOTES_STORE } from '../../constants';
import { Quote } from '../../types/quote';
import { twMerge } from 'tailwind-merge';

interface AdditionalMessagesProps {
    quote: Quote;
}

const AdditionalMessages: React.FC< AdditionalMessagesProps > = ( {
    quote,
} ) => {
    const dispatch = useDispatch( VENDOR_QUOTES_STORE );
    const storeInfo = quote?.store_info;
    const customerInfo = { ...quote?.customer_info, ...quote?.customer };
    const isPendingQuote = quote?.status === 'pending';

    const vendorAdditionalMsgHandler = (
        event: React.ChangeEvent< HTMLTextAreaElement >
    ) => {
        dispatch.setQuote( {
            ...quote,
            store_info: {
                ...storeInfo,
                vendor_additional_msg: event.target.value,
            },
        } );
    };

    return (
        <Card className="rounded-lg shadow overflow-hidden">
            <Card.Header>
                <Card.Title className="m-0">
                    <div className="flex items-center gap-3">
                        <svg
                            width="28"
                            height="28"
                            viewBox="0 0 28 28"
                            fill="none"
                        >
                            <path
                                d="M23.8691 17.752C23.8691 18.3487 23.6321 18.921 23.2101 19.3429C22.7882 19.7649 22.2159 20.002 21.6191 20.002H8.11914L3.61914 24.502V6.50195C3.61914 5.90522 3.85619 5.33292 4.27815 4.91096C4.70011 4.48901 5.2724 4.25195 5.86914 4.25195H21.6191C22.2159 4.25195 22.7882 4.48901 23.2101 4.91096C23.6321 5.33292 23.8691 5.90522 23.8691 6.50195V17.752Z"
                                stroke="#000"
                                strokeWidth="2.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                        <h3 className="text-lg font-semibold">
                            { __( 'Additional Message', 'dokan' ) }
                        </h3>
                    </div>
                </Card.Title>
            </Card.Header>
            <Card.Body>
                <div className="space-y-4">
                    { customerInfo?.customer_additional_msg && (
                        <div className="flex gap-4">
                            <img
                                alt={ customerInfo?.user_login }
                                src={ customerInfo?.user_avatar }
                                className="w-10 h-10 rounded-full"
                            />
                            <div>
                                <div className="font-medium text-black">
                                    { customerInfo?.name_field }
                                </div>
                                <p className="text-gray-600">
                                    { customerInfo?.customer_additional_msg }
                                </p>
                            </div>
                        </div>
                    ) }

                    { isPendingQuote ? (
                        <div className="border rounded-lg overflow-hidden">
                            <textarea
                                className="bg-white shadow-none"
                                rows={
                                    customerInfo?.customer_additional_msg
                                        ? 2
                                        : 3
                                }
                                onChange={ vendorAdditionalMsgHandler }
                                placeholder={ sprintf(
                                    __( 'Reply to %s…', 'dokan' ),
                                    customerInfo?.name_field
                                ) }
                            ></textarea>
                        </div>
                    ) : (
                        storeInfo?.vendor_additional_msg && (
                            <div
                                className={ twMerge(
                                    'flex gap-4',
                                    customerInfo?.customer_additional_msg &&
                                        'border-t mt-4 pt-4'
                                ) }
                            >
                                <img
                                    alt={ storeInfo?.store_name }
                                    src={ storeInfo?.user_avatar }
                                    className="w-10 h-10 rounded-full"
                                />
                                <div>
                                    <div className="font-medium text-black">
                                        { storeInfo?.store_name }
                                    </div>
                                    <p className="text-gray-600">
                                        { storeInfo?.vendor_additional_msg }
                                    </p>
                                </div>
                            </div>
                        )
                    ) }
                </div>
            </Card.Body>
        </Card>
    );
};

export default AdditionalMessages;
